module.exports = __webpack_public_path__ + "img/unlimited-bandwidth.64dd5db8.svg";